import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, GetNearestTableAncestorId, ApiRequest, ReturnTimeZone } from '../../helpers';
import { arrayMove } from 'react-sortable-hoc';
import ReactDOM from 'react-dom';
import Message from '../Common/Message/Message';
import FlexpassForm from './FlexpassForm/FlexpassForm';
import FlexpassPricing from './FlexpassPricing/FlexpassPricing';
import FlexpassDates from './FlexpassDates/FlexpassDates';
import FlexpassDatesModal from './FlexpassDatesModal/FlexpassDatesModal';
import FlexpassEvents from './FlexpassEvents/FlexpassEvents';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class CreateFlexpass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPublished: true,
            events: [],
            selectedEvents: [],
            isReadyToSelectEvents: false,
            isReadyToSubmit: false,
            flexpassExists: false,
            activeFlexpass: {},
            isDatesModalOpen: false,
            flexpassDetails: {
                details: {
                    id: 0,
                    flexName: '',
                    contactEmail: '',
                    flexShortName: '',
                    contactPhone: '',
                    flexDescription: '',
                    flexWebsite: '',
                    serviceFee: 'client',
                    flexQuantityToPurchase: 0,
                    ticketsQuantityToRedeem: 0,
                    poster: undefined,
                    advertisement: undefined,
                    poster_graphic_url: undefined,
                    ad_graphic_url: undefined
                },
                prices: [
                    {
                        id: 0,
                        name: '',
                        price: null,
                        delete: true,
                        value: "all",
                        validation: {
                            name: true,
                            price: true
                        }
                    }
                ],
            },
            validation: {
                details: {
                    flexName: {
                        valid: null,
                        msg: ''
                    },
                    contactEmail: {
                        valid: null,
                        msg: ''
                    },
                    contactPhone: {
                        valid: null,
                        msg: ''
                    } ,
                    flexQuantityToPurchase: {
                        valid: true,
                        msg: ''
                    },
                    ticketsQuantityToRedeem: {
                        valid: true,
                        msg: ''
                    }
                },
                prices: {
                    name: {
                        valid: null,
                        msg: ''
                    },
                    price: {
                        valid: null,
                        msg: ''
                    }
                }
            },
            wizard: {
                presale: {
                    start_date: '',
                    start_time: '00:00',
                    end_date: '',
                    end_time: '00:00',
                    password: ''
                },
                public: {
                    start_date: moment(new Date()),
                    start_time: '00:00',
                    end_date: moment().endOf('year'),
                    end_time: '00:00',
                },
                boxoffice: {
                    end_date: moment().endOf('year'),
                    end_time: '00:00',
                },
                prices: [],
                timezone: 'AST'
            },
            message: {
                title: '',
                content: '',
                type: ''
            },
            showNoEventsWarning: false
        }
    }

    componentDidUpdate() {
        let hash = this.props.routeProps.history.location.hash.replace('#', '');
        if (hash) {
            let node = ReactDOM.findDOMNode(this.refs[hash]);
            if (node) {
                node.scrollIntoView();
            }
        }
    }

    componentDidMount() {
        this.checkIfFlexpassExists();
        this.validateAllRequiredFields();
        this.checkIfAddRow('prices');
        this.getEventsList();
    }

    componentWillReceiveProps(props) {
        if(props.saveFlexpassMode){
            // Clear Save Coupon mode to avoid duplicate call
            this.props.saveUpdateFlexpassEvent(false);
            // Save the flexpass
            this.saveFlexpass();
        }
    }

    componentWillUnmount() {
        this.props.enableSaveFlexpassButton(false);
        this.props.toggleFlexpassExists(false);
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    checkIfFlexpassExists() {
        // If flexpass ID has been passed
        const params = this.props.routeProps.match.params;
        if(params && params.id) {
            this.setState({ flexpassExists: true });
            this.props.toggleFlexpassExists(true);

            // populate activeFlexpass object
            this.getActiveFlexpassInfo(params.id);
        }
    }

    getActiveFlexpassInfo = (flexpassId) => {
        (async () => {
            try {
                const activeFlexpassInfoResponse = await activeFlexpassInfo();
                console.log('active flexpass info response: ', activeFlexpassInfoResponse);

                if(activeFlexpassInfoResponse.data.flexpass){
                    let response = activeFlexpassInfoResponse.data.flexpass;
                    this.setMessage('','','');

                    // set all required fields to valid
                    let validation = {...this.state.validation};
                    for (let type in validation) {
                        for (let field in validation[type]) {
                            validation[type][field]['valid'] = true;
                        }
                    }

                    let prices = this.state.flexpassDetails.prices;
                    if(response.pricing_options.length > 0) {
                        prices = response.pricing_options.map((p, i) => {
                            return {
                                id: i,
                                name: p.desc,
                                price: p.amount,
                                delete: true,
                                value: p.visibility,
                                validation: {
                                    name: true,
                                    price: true
                                }
                            }
                        });
                        prices.push(
                            {
                                id: Date.now(),
                                name: '',
                                price: null,
                                delete: false,
                                value: "all",
                                validation: {
                                    name: '',
                                    price: ''
                                }
                            }
                        )
                    }

                    let activeFlexpass = {
                        details: {
                            id: response.id,
                            flexName: response.name,
                            contactEmail: response.contact_email,
                            flexShortName: response.short_name,
                            contactPhone: response.contact_phone,
                            flexDescription: response.desc,
                            flexWebsite: response.website,
                            serviceFee: response.service_fee,
                            flexQuantityToPurchase: response.max_purchases,
                            ticketsQuantityToRedeem: response.max_tickets,
                            poster: (response.poster_graphic_id) ? response.poster_graphic_id : undefined,
                            advertisement: (response.ad_graphic_id) ? response.ad_graphic_id : undefined,
                            poster_graphic_url: response.poster_graphic_url,
                            ad_graphic_url: response.ad_graphic_url
                        },
                        prices: prices
                    }

                    let wizard = { ...this.state.wizard };
                    wizard['prices'] = response.pricing_options;
                    wizard['presale']['password'] = response.presale_password;
                    wizard['presale']['start_date'] = (response.presale_start) ? moment.tz(response.presale_start, response.time_zone) : this.state.wizard.presale.start_date;
                    wizard['presale']['start_time'] = (response.presale_start) ? moment.tz(response.presale_start, response.time_zone).toString().substring(16,21) : this.state.wizard.presale.start_time;
                    wizard['presale']['end_date'] = (response.presale_end) ? moment.tz(response.presale_end, response.time_zone) : this.state.wizard.presale.end_date;
                    wizard['presale']['end_time'] = (response.presale_end) ? moment.tz(response.presale_end, response.time_zone).toString().substring(16,21) : this.state.wizard.presale.end_time;
                    wizard['public']['start_date'] = (response.sale_start) ? moment.tz(response.sale_start, response.time_zone) : this.state.wizard.public.start_date;
                    wizard['public']['start_time'] = (response.sale_start) ? moment.tz(response.sale_start, response.time_zone).toString().substring(16,21) : this.state.public.presale.start_time;
                    wizard['public']['end_date'] = (response.sale_start) ? moment.tz(response.sale_end, response.time_zone) : this.state.wizard.public.end_date;
                    wizard['public']['end_time'] = (response.sale_start) ? moment.tz(response.sale_end, response.time_zone).toString().substring(16,21) : this.state.wizard.public.end_time;
                    wizard['boxoffice']['end_date'] = (response.sale_end_box_office) ? moment.tz(response.sale_end_box_office, response.time_zone) : this.state.wizard.boxoffice.end_date;
                    wizard['boxoffice']['end_time'] = (response.sale_end_box_office) ? moment.tz(response.sale_end_box_office, response.time_zone).toString().substring(16,21) : this.state.wizard.boxoffice.end_time;
                    wizard['timezone'] = response.time_zone;


                    let selectedEvents = response.event_date_ids;

                    this.setState({ 
                        activeFlexpass: activeFlexpass,
                        flexpassDetails: activeFlexpass,
                        selectedEvents: selectedEvents,
                        validation: validation,
                        wizard: wizard
                    });
                    this.validateAllRequiredFields();
                } else {
                    this.setMessage(window.general_strings.msg.oops, activeFlexpassInfoResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function activeFlexpassInfo() {
            return await ApiRequest('/flexpass/' + flexpassId, {
                method: 'GET'
            });
        }
    }

    handleChange = (e) => {
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        const name = e.target.name;
        if (e.target.type === "radio") {
            value = e.target.attributes.getNamedItem('radioname').value;
        }
        const flexpassDetails = {...this.state.flexpassDetails};

        flexpassDetails[key][name] = value;
        this.setState({ flexpassDetails });

        if (e.target && e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.validation.value;
            this.validate(value, key, name, validationRegEx);
        }

        this.validateRequiredField(e);
    }

    validate = (value, key, name, validationRegEx) => {
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value)) {
            value === '' ? validation[key][name]['msg'] = strings.errorRequired : validation[key][name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        validation[key][name]['valid'] = isValid;
        this.setState({ validation });
    }

    validateRequiredField = (e) => {
        if (e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const key = e.target.attributes.getNamedItem('object').value;
            const name = e.target.name;
            const validation = { ...this.state.validation };
            validation[key][name]['msg'] = strings.errorRequired;
            validation[key][name]['valid'] = false;
            this.setState({ validation });
        }
        this.validateAllRequiredFields();
    }  
    
    validateAllRequiredFields = () => {
        let validation = { ...this.state.validation.details };
        const flexpassDetails = {...this.state.flexpassDetails}
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let i = Object.keys(validation).length;
        for (let field in validation) {
            if (validation[field]['valid'] === true) {
                i--;
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
        this.props.enableSaveFlexpassButton(isReadyToSubmit);
    }

    updateFile = (data, name) => {
        const flexpassDetails = { ...this.state.flexpassDetails };
        flexpassDetails['details'][name] = data.upload.id;

        this.setState({ 
            flexpassDetails
        }, 
        () => {
            this.setMessage('','','');
        });
    }

    uploadFile = (file, name, croppedFile) => {
        this.setMessage('','','loading');
        (async () => {
            try {
                const uploadFileResponse = await uploadFile(croppedFile);
                if(uploadFileResponse.data.upload){
                    this.updateFile(uploadFileResponse.data, name);
                } else {
                    this.setMessage(window.general_strings.msg.oops,strings.msg.wrong,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function uploadFile(file) {
            const formData = new FormData();
            formData.append('file', file);

            return await ApiRequest('/uploads', {
                method: 'POST',
                contentType: 'multipart/form-data',
                data: formData
            });
        }
    }

    clearFile = (e) => {
        const flexpassDetails = { ...this.state.flexpassDetails };
        flexpassDetails['details'][e.target.getAttribute('objectname')] = '';
        this.setState({ flexpassDetails });
    }

    handleSortableInputs = (e) => {
        let value = e.target.value;
        let key = e.target.attributes.getNamedItem('object').value;
        let id = parseInt(e.target.attributes.getNamedItem('id').value, 0);
        let name = e.target.name;

        let flexpassDetails = { ...this.state.flexpassDetails };
        var index = flexpassDetails[key].findIndex(x => x.id === id);
        flexpassDetails[key][index][name] = value;
        this.setState({ flexpassDetails });

        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, key, name, validationRegEx, index);
        }
        this.checkIfAddRow(key);
    }

    checkIfAddRow = (key) => {
        const flexpassDetails = {...this.state.flexpassDetails};
        let noEmptyValues = true;
        flexpassDetails[key].forEach((obj, index) => {
            for (let o in obj) {
                if (obj[o] === '') {
                    noEmptyValues = (o === 'position');
                    break;
                } 
            }
            noEmptyValues ? obj['delete'] = true : obj['delete'] = false;
            this.setState({ flexpassDetails });
        });

        noEmptyValues && this.addRow(key);
    }
    
    addRow = (key) => {
        const flexpassDetails = {...this.state.flexpassDetails};
        const obj = Object.assign({}, flexpassDetails[key][0]);
        for (let o in obj) {
            if (o === 'id') {
                obj[o] = Date.now();
            }
            else if (o === 'validation') {
                obj[o] = {
                    name: '',
                    price: ''
                };
            }
            else if (o === 'value') {
                obj[o] = 'all';
            }
            else {
                obj[o] = '';
            }
        }
        obj['delete'] = false;
        flexpassDetails[key].push(obj); 
        this.setState({ flexpassDetails });
    }

    deleteRow = (e) => {
        const key = e.target.attributes.getNamedItem('object').value;
        const id = parseInt(e.target.id, 0);
        const flexpassDetails = {...this.state.flexpassDetails};
        if(flexpassDetails.isPublished && key === 'prices'){
            this.toggleConfirmDeletePrice(true);
        } else {
            var index = flexpassDetails[key].findIndex(x => x.id === id);
            flexpassDetails[key].splice(index,1);
            this.setState({ flexpassDetails });
        }
	}

    onSortEnd = ({oldIndex, newIndex}, e) => {
        if(oldIndex !== newIndex){
            const flexpassDetails = { ...this.state.flexpassDetails };
            const currentDragTable = this.state.currentDragTable;
            flexpassDetails[currentDragTable] = arrayMove(flexpassDetails[currentDragTable], oldIndex, newIndex)
            this.setState({ flexpassDetails });
        }
    };

    onSortStart = ({node}) => {
        const currentDragTable = GetNearestTableAncestorId(node);
        this.setState({ currentDragTable });
    };

    getEventsList = () => {
        (async () => {
            try {
                const eventsListResponse = await eventsList();
                console.log('events list response: ', eventsListResponse);

                if(eventsListResponse.data.event_dates){
                    if(eventsListResponse.data.event_dates.length > 0) {
                        this.setState({ showNoEventsWarning: false });
                        this.setMessage('','','');

                        let events = eventsListResponse.data.event_dates.map(e => {
                            return {
                                id: e.event_date_id,
                                name: e.event_name,
                                date: moment(e.event_datetime_local.substring(0, 19)),
                                type: e.event_type,
                                licensing: e.licensing
                            }
                        });

                        this.setState({
                            events,
                            isReadyToSelectEvents: true
                        });

                        // select all events by default
                        if (!this.state.flexpassExists) {
                            // this.selectAllEventCheckboxes({target:{value: true, checked: true}});
                        } else {
                            this.setState({
                                isReadyToSelectEvents: true
                            });
                        }

                    } else {
                        this.setState({ showNoEventsWarning: true });
                    }
                } else {
                    this.setMessage(window.general_strings.msg.oops, eventsListResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function eventsList() {
            return await ApiRequest('/event-dates', {
                method: 'GET'
            });
        }
    }

    checkIfEnEventIsMtiOrCt = () => {
        // IF an event is streaming type
        // AND has MTI or CT as licensing house
        // AND flexpass price is 0
        // THEN throw error and not save
        let hasAPriceGreaterThanZero = false;
        for (let price of this.state.flexpassDetails.prices) {
            if (parseFloat(price.price) > 0) {
                hasAPriceGreaterThanZero = true;
                break;
            }
        }

        let anEventIsMtiOrCt = false;
        if (hasAPriceGreaterThanZero) {
            this.state.selectedEvents.forEach((eventId) => {
                let activeEvent;
                for (let event of this.state.events) {
                    if (event.id === eventId) {
                        activeEvent = event;
                        if (
                            (activeEvent.type === 'Live Stream' || activeEvent.type === 'Scheduled Content' || activeEvent.type === 'Video On Demand') &&
                            (activeEvent.licensing === 'MTI' || activeEvent.licensing === 'CT')
                        ) {
                            anEventIsMtiOrCt = true;
                            break;
                        }
                    }

                }
            });
        }
        return anEventIsMtiOrCt;
    };

    saveFlexpass = () => {
        this.setMessage('','','loading');

        if (this.checkIfEnEventIsMtiOrCt()) {
            window.scrollTo(0, 0);
            this.setMessage(window.general_strings.msg.oops, strings.errorStreamingPrice, 'error');
            return;
        }

        // get infos
        let flexpassDetails = {...this.state.flexpassDetails.details}
        let pricingOptions = this.state.flexpassDetails.prices.filter(function(p) { // remove empty pricing options
            if (p.name === "" && (p.price === "" || p.price === null)) return false;
            return true;
        }).map(p => {
            return {
                desc: p.name,
                amount: parseFloat(p.price),
                visibility: p.value
            }
        });

        let presaleStart = this.formatDate(this.state.wizard.presale.start_date, this.state.wizard.presale.start_time);
        let presaleEnd = this.formatDate(this.state.wizard.presale.end_date, this.state.wizard.presale.end_time);
        let saleStart = this.formatDate(this.state.wizard.public.start_date, this.state.wizard.public.start_time);

        let saleEnd = this.formatDate(this.state.wizard.public.end_date, this.state.wizard.public.end_time);
        let saleEndBoxOffice = this.formatDate(this.state.wizard.boxoffice.end_date, this.state.wizard.boxoffice.end_time);

        // construct object to send
        const flexpass = {
            name: flexpassDetails.flexName,
            short_name: flexpassDetails.flexShortName,
            desc: flexpassDetails.flexDescription,
            contact_email: flexpassDetails.contactEmail,
            contact_phone: flexpassDetails.contactPhone,
            website: flexpassDetails.flexWebsite,
            service_fee: flexpassDetails.serviceFee,
            max_purchases: parseInt(flexpassDetails.flexQuantityToPurchase, 10),
            max_tickets: parseInt(flexpassDetails.ticketsQuantityToRedeem, 10),
            poster_graphic_id: flexpassDetails.poster,
            ad_graphic_id: flexpassDetails.advertisement,
            event_date_ids: this.state.selectedEvents,
            pricing_options: pricingOptions,
            presale_start: presaleStart,
            presale_end: presaleEnd,
            presale_password: this.state.wizard.presale.password,
            sale_start: saleStart,
            sale_end: saleEnd,
            sale_end_box_office: saleEndBoxOffice,
            time_zone: this.state.wizard.timezone
        };

        const requestUrl = (this.state.flexpassExists) ? '/flexpass/' + this.state.flexpassDetails.details.id : '/flexpass';
        const requestMethod = (this.state.flexpassExists) ? 'PUT' : 'POST';

        (async () => {
            try {
                const createFlexpassResponse = await createFlexpass(flexpass);
                console.log('create flexpass response: ', createFlexpassResponse);

                if((!this.state.flexpassExists && createFlexpassResponse.data.flexpass) || (this.state.flexpassExists && createFlexpassResponse.data.success === true) ){
                    this.setMessage(window.general_strings.msg.yay, strings.msg.success, 'success');

                    if(typeof createFlexpassResponse.data.flexpass !== 'undefined'){
                        this.props.routeProps.history.push('/create-flexpass/' + createFlexpassResponse.data.flexpass.id);
                        this.setState({flexpassExists: true});
                        this.props.toggleFlexpassExists(true);
                        this.getActiveFlexpassInfo(createFlexpassResponse.data.flexpass.id);
                    }
                } else {
                    this.setMessage(window.general_strings.msg.oops, createFlexpassResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
            window.scrollTo(0, 0);
        })()

        async function createFlexpass(flexpass) {
            return await ApiRequest(requestUrl, {
                method: requestMethod,
                data: flexpass
            });
        }
    }

    selectAllEventCheckboxes = (e) => {
        let value = e.target.value;
        (e.target.checked) ? value = true : value = false;
        var table = document.getElementById('flexpassEventsTbl');
        var inputs = table.querySelectorAll('input');
        inputs.forEach((input) => {
            input.checked = value;
        });

        this.updateSelectedEvents();
    }

    updateSelectedEvents = () => {
        const table = document.getElementById('flexpassEventsTbl');
        const inputs = table.querySelectorAll('input');
        let selectedEvents = [];

        inputs.forEach((input) => {
            if(input.checked && input.id != 'input-event-all') {
                selectedEvents.push(parseInt(input.id.replace("input-event-", ""), 10));
            }
        });
        
        let isReadyToSelectEvents = selectedEvents.length > 0;
        this.setState({ 
            selectedEvents,
            isReadyToSelectEvents
        });
    }

    /////* dates stuff */
    toggleDatesModal = () => {
        this.setState({
            isDatesModalOpen: !this.state.isDatesModalOpen
        });
    }

    savePricing = () => {
        this.setPricing();
        this.setState({
            isDatesModalOpen: false
        });
    }

    setPricing = (event) => {
        const inputs = document.querySelectorAll('.js-section-price');
        let pricesArr = [];
        inputs.forEach((input, i) => {
            const value = input.value;
            const price = input.attributes.getNamedItem('price').value;

            let priceObj = {};
            priceObj.id = parseInt(input.id.replace("price-", ""), 10);
            priceObj.price = price;
            priceObj.value = value;

            pricesArr.push(priceObj);
        });

            const wizard = {...this.state.wizard};
            wizard['prices'] = pricesArr;
            this.setState({ wizard });

        const flexpassDetails = {...this.state.flexpassDetails};
        flexpassDetails.prices.forEach(function(detailsPrice, i){
            pricesArr.forEach(function(wizardPrice, j){
                if (parseInt(wizardPrice.id, 10) == parseInt(detailsPrice.id, 10)) {
                    flexpassDetails['prices'][i].value = wizardPrice.value;
                }
        })
    })
        this.setState({ flexpassDetails });
    }

    handleChangeWizard = (e) => {
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        let name = '';
        if(e.target.name !== ''){
            name = e.target.name;
        }

        const wizard = {...this.state.wizard};
        if(name !== ''){
            wizard[key][name] = value;
        } else {
            wizard[key] = value;
        }
    
        this.setState({ wizard });
    }

    handleChangeDateWizard = (value, key, name) => {
        const wizard = {...this.state.wizard};
        if(name){
            wizard[key][name] = value;
        } else {
            // Sort dates to have them in ascending order so it's easier to calculate other entries
            value.sort((a,b) => {
                var c = new Date(a);
                var d = new Date(b);
                return c-d;
            });
            wizard[key] = value;
        }

        // Check if public start date is AFTER presale end date
        if(wizard.presale.end_date !== null && wizard.public.start_date !== null){
            if(moment(wizard.presale.end_date) > moment(wizard.public.start_date)){
                this.setState({ isWizardError : true });
            } else {
                this.setState({ isWizardError : false });
            }
        } else {
            this.setState({ isWizardError : false });
        }
        this.setState({ wizard });
    }

    formatDate = (date, time) => {
        // Calculate the different between user and UTC time in minutes
        const timestamp = new Date();
        const timezone = this.state.wizard.timezone;
        const inverseOffset = moment().tz(timezone).format().substring(20,22) * 60;
        if (date === '' || time === '') {
            return undefined;
        } else {
            let hours = parseInt(time.substring(0, 2), 10);
            let minutes = parseInt(time.substring(3, 5), 10);
            return moment(date).hour(hours).minutes(minutes).add(inverseOffset, 'minutes').format();
        }
    }

    render() { 
        return ( 
            <div>
                {this.state.showNoEventsWarning &&
                <div className="container">
                    <Message
                        message={
                            {
                                title: window.general_strings.msg.warning,
                                content: strings.msg.noEvents,
                                type: ''
                            }
                        }
                    />
                </div>
                }
                <div className="container">
                    <Message
                        message={this.state.message}
                    />
                </div>
                <FlexpassForm
                    activeFlexpass={this.state.activeFlexpass}
                    flexpassDetails={this.state.flexpassDetails}
                    validation={this.state.validation} 
                    handleChange={this.handleChange} 
                    validate={this.validate}
                    uploadFile={this.uploadFile}
                    clearFile={this.clearFile}
                />
                <FlexpassPricing 
                    activeFlexpass={this.state.activeFlexpass}
                    flexpassDetails={this.state.flexpassDetails}
                    handleSortableInputs={this.handleSortableInputs} 
                    onSortEnd={this.onSortEnd}
                    onSortStart={this.onSortStart}
                    deleteRow={this.deleteRow}
                />
                <FlexpassDates 
                    flexpassDetails={this.state.flexpassDetails}
                    toggleDatesModal={this.toggleDatesModal}
                    handleChangeWizard={this.handleChangeWizard}
                    handleChangeDateWizard={this.handleChangeDateWizard}
                    wizard={this.state.wizard}
                    isWizardError={this.state.isWizardError}
                />
                <FlexpassDatesModal
                    flexpassDetails={this.state.flexpassDetails}
                    isDatesModalOpen={this.state.isDatesModalOpen}
                    toggleDatesModal={this.toggleDatesModal}
                    savePricing={this.savePricing}
                />
                <FlexpassEvents 
                    activeFlexpass={this.state.activeFlexpass}
                    selectedEvents={this.state.selectedEvents}
                    events={this.state.events}
                    isReadyToSelectEvents={this.state.isReadyToSelectEvents}
                    isReadyToSubmit={this.state.isReadyToSubmit}
                    flexpassExists={this.state.flexpassExists}
                    selectAllEventCheckboxes={this.selectAllEventCheckboxes}
                    updateSelectedEvents={this.updateSelectedEvents}
                    saveFlexpass={this.saveFlexpass}
                />
            </div>    
        )
    }
}

CreateFlexpass.propTypes = {}
 
export default CreateFlexpass;


// WEBPACK FOOTER //
// ./src/components/CreateFlexpass/CreateFlexpass.js